import { render, staticRenderFns } from "./RtoHistory.vue?vue&type=template&id=60fb6b1c&scoped=true&"
import script from "./RtoHistory.vue?vue&type=script&lang=js&"
export * from "./RtoHistory.vue?vue&type=script&lang=js&"
import style0 from "./RtoHistory.vue?vue&type=style&index=0&id=60fb6b1c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60fb6b1c",
  null
  
)

export default component.exports